var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullscreenTownSelect',{attrs:{"is-active":_vm.isActive,"hide-on-select":false,"hide-activator":""},on:{"update:isActive":function($event){_vm.isActive=$event},"update:is-active":function($event){_vm.isActive=$event}},model:{value:(_vm.town),callback:function ($$v) {_vm.town=$$v},expression:"town"}})
}
var staticRenderFns = []

export { render, staticRenderFns }